<template>
  <el-tooltip
    :disabled="enableTooltip"
    :content="text"
    placement="top"
    :open-delay="300"
  >
    <span class="break-word">{{ text_ }}</span>
  </el-tooltip>
</template>

<script>
import utils from "../../../services/utils";

export default {
  name: "break-word-span",
  props: ["text", "maxLength"],

  data() {
    return {
      text_: "",
      enableTooltip: false
    };
  },

  watch: {
    text() {
      this.initText();
    },
    maxLength() {
      this.initText();
    }
  },

  created() {
    this.initText();
  },

  methods: {
    initText() {
      this.text_ = utils.getShortString(this.text || "", {
        maxLength: this.maxLength
      });
      this.enableTooltip = (this.text_ || "") === (this.text || "");
    }
  }
};
</script>

<style scoped>
.break-word {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/break-word-span.vue